/**
 * @fileoverview Agent definition for critique-sensory-atmosphere.
 *
 * This agent analyzes prose for imagery, sensory details, show vs tell,
 * scene grounding, and atmospheric consistency.
 *
 * @category narrative.prose.critique
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'critique-sensory-atmosphere',
  kind: 'primitive',
  name: 'Sensory & Atmosphere Critic',
  description: 'Analyzes prose for imagery, sensory details, show vs tell, scene grounding, and atmospheric consistency.',
  category: 'writing',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2024-08',
    lastUpdated: '2026-01',
    taxonomyPath: 'narrative.prose.critique',
    usedBy: [
      'use-critique-sensory-atmosphere.ts',
    ],
    usedInComposites: [
      'critique-committee-v2',
    ],
    relatedAgents: [
      'critique-prose-flow',
      'critique-voice-emotion',
    ],
  },
};
